<template> 

    <v-menu offset-y :bottom="bottom" :left="left" :offset-x="isSubMenu||offsetX" :nudge-left="compNudgeLeft" :nudge-bottom="compNudgeBottom" :closeOnContentClick="closeOnContentClick">
        <template v-slot:activator="{ on }">
            <span v-on="on" :dusk="dusk">
                <slot></slot>
            </span>
        </template>
        <slot name="dropmenu">
            <v-list dense>
                <slot name="dropdown"></slot>
            </v-list>
        </slot>
    </v-menu>

</template>

<script setup>

/*

    Usage: 
    
        import ActionMenu from "@controls/menu/ActionMenu.vue";        
        import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";        
        <ActionMenu>
            <ActionButton ml link-button  icon="add">Tekstregel</ActionButton>
            <template v-slot:dropdown>
                <ActionMenuItem action="salesinvoice.modify" no-execute :disabled="model.disabled||model.isDataLoading" @click="()=>addEmptyText()"></ActionMenuItem>
                <ActionMenuItem action="salesinvoice.modify" no-execute :disabled="model.disabled||model.isDataLoading" @click="()=>addStandardText()"></ActionMenuItem>
            </template>
        </ActionMenu>
        
*/

    import {computed, ref} from 'vue'
    
    const props = defineProps({
        closeOnContentClick: {
            type: [Boolean],
            default: true
        },
        bottom: {
            type: [Boolean],
            default: true
        },
        left: {
            type: [Boolean],
            default: false
        },
        nudgeBottom: {
            type: [String, Number],
        },
        nudgeLeft: {
            type: [String, Number],
        },
        dusk: {
            type: [String],
        },
        offsetX: {
            type: [Boolean],
            default: false
        },
        isSubMenu: {
            type: [Boolean],
            default: false
        },
    })

    const compNudgeBottom = computed({
        get() {
            if (props.nudgeBottom) {
                return props.nudgeBottom
            }
            if (props.isSubMenu) {
                return -48;
            }
            return props.nudgeBottom
        }
    })
    const compNudgeLeft = computed({
        get() {

            if (props.nudgeLeft) {
                return props.nudgeLeft
            }
            if (props.isSubMenu) {
                return -4;
            }
            return props.nudgeLeft
        }
    })

</script>